<style lang="scss" scoped>
@import '$vars';
@screen mobile {
  nav {
    @apply m-0;
  }
  .nav {
    @apply m-0;
    a {
      @apply border-0;
      border-left-width: 1rem !important;
      &.active {
        @apply border-blueAlt #{!important} ;
      }
    }
  }
}

ul {
  padding-top: 20px;
  margin: 0 -0.8em;

  li {
    width: 100%;
    font-size: 0.9em;
    border-top: 1px solid #e1e1e1;
    margin-top: -1px;

    &:last-child {
      border-bottom: 1px solid #e1e1e1;
    }

    a {
      display: block;
      width: 100%;
      padding: 15px 50px !important;
      transition: all 200ms;
      border-left: 6px solid transparent;

      &.active {
        border-left: 6px solid $color-blue;
        background: lighten($color-blue, 40);
      }

      &.d-flex {
        align-items: center;
        display: flex;
      }

      &:hover {
        .caret {
          &:after,
          &:before {
            background-color: #56bdd2;
          }
        }
      }
    }

    .v-icon {
      width: 20px;
      height: 20px;
      margin-right: 10px
    }
  }
}

.caret {
  display: block;
  height: 10px;
  position: relative;
  width: 10px;
  transition: all 0.3s ease;

  &--active {
    transform: rotate(180deg);
    transition: all 0.3s ease;
  }

  &:after,
  &:before {
    content: '';
    background-color: #747879;
    height: calc(70% - 1px);
    margin-top: -35%;
    position: absolute;
    top: 50%;
    width: 1px;
  }

  &:after {
    right: 0;
    margin-right: 25%;
    transform: rotate(45deg);
  }

  &:before {
    left: 0;
    margin-left: 25%;
    transform: rotate(-45deg);
  }

  &-wrapper {
    align-items: center;
    cursor: pointer;
    display: flex;
    box-sizing: border-box;
    height: 10px;
    justify-content: center;
    margin: 5px 5px 0 5px;
    width: 10px;
  }
}

.anamnesis-list {
  border-bottom: none;
  box-sizing: border-box;
  list-style-type: none;
  margin: 0;
  padding: 0;

  &__item {
    border: none;
    background-color: #f7fcfd;
    padding: 10px 10px 10px 70px;

    &:first-child {
      border-top: 1px solid #e1e1e1;
    }

    a {
      margin: 0;
      padding: 0 !important;
    }
  }
}

ul.nav {
  box-sizing: border-box;

  li.nav-item {
    box-sizing: border-box;

    a {
      box-sizing: border-box;

      &.patient-files {
        border-left: 6px solid $color-yellow;
        background-color: lighten($color-yellow, 45%);

        &:hover {
          color: darken($color-yellow, 10%);
        }
      }
     }
  }
}
</style>

<template>
  <ul class="nav">
    <li
      v-for="section in sections"
      :key="section.component"
      class="nav-item"
    >
      <template v-if="section.isVisible">
        <a
          v-if="section.component !== 'anamnesis'"
          :class="{
            'patient-files': section.component === 'patientFiles',
            'active': section.component === selectedComponent
          }"
          @click="selectComponent(section)"
        >
          {{ section.name }}
        </a>

        <template v-else>
          <template v-if="section.loading">
            <a class="d-flex">
              {{ section.name }} &emsp;

              <dr-loader size="sm" />
            </a>
          </template>

          <template v-else-if="section.options.length > 0">
            <a
              class="d-flex"
              :class="section.component === selectedComponent ? 'active' : ''"
              @click="section.showList = !section.showList"
            >
              {{ section.name }}

              <div class="caret-wrapper">
                <span
                  class="caret"
                  :class="section.showList ? ' caret--active' : ''"
                />
              </div>
            </a>

            <ul
              v-if="section.showList"
              class="anamnesis-list"
            >
              <li
                v-for="(option, i) in section.options"
                :key="`${section.name}_${i}`"
                class="anamnesis-list__item"
              >
                <a @click.prevent="chooseAnamnesis(option.id)">
                  {{ option.name }}
                </a>
              </li>
            </ul>
          </template>

          <template v-else>
            <a
              :class="section.component === selectedComponent ? 'active' : ''"
              @click="selectComponent(section)"
            >
              {{ section.name }}
            </a>
          </template>
        </template>
      </template>

      <!-- <router-link :class="route.name === $route.name ? 'active' : ''" :to="{name: route.name}">
        <dr-icon
          :name="route.meta.icon"
          :fill="getColor(route.name)" ></dr-icon>
        {{route.meta.title}}
      </router-link> -->
    </li>
  </ul>
</template>
<script>
export default {
  name: 'DrAppointmentSubmenu',

  props: {
    selected: {
      required: false
    },

    schedulingType: {
      required: false
    },

    isPatientFilesVisible: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },

  data () {
    return {
      selectedComponent: null,
      appointmentId: this.$route.params.agendaId,
      sections: [
        {
          name: 'Avaliação clínica',
          component: 'clinicalEvaluation',
          isVisible: true
        },
        {
          name: 'Autoavaliação',
          component: 'selfEvaluation',
          isVisible: this.schedulingType === 'DRCONECTA'
        },
        {
          name: 'Anamnese',
          component: 'anamnesis',
          showList: false,
          options: [],
          loading: false,
          isVisible: true
        },
        {
          name: 'Pedidos médicos',
          component: 'medicalRequest',
          isVisible: true
        },
        {
          name: 'Atestados',
          component: 'sickNote',
          isVisible: true
        },
        {
          name: 'Documentos médicos',
          component: 'files',
          isVisible: true
        },
        {
          name: 'Documentos compartilhados',
          component: 'patientFiles',
          isVisible: false
        }
      ]
    }
  },

  watch: {
    selected: {
      deep: true,
      immediate: true,
      handler (value) {
        this.selectedComponent = value
      }
    },

    isPatientFilesVisible: {
      deep: false,
      immediate: true,
      handler (value) {
        if (value) {
          this.sections
            .find((section) => section.component === 'patientFiles')
            .isVisible = true
        }
      }
    }
  },

  mounted () {
    this.init()
    this.sections[this.sections.findIndex(s => s.component === 'anamnesis')].loading = true
  },

  methods: {
    init () {
      this.getAppointmentAnamnesis(this.appointmentId)
        .then(res => this.setAnamnesisList(res))
        .catch(err => console.warn('err\n', err))
        .finally(() => { this.sections[this.sections.findIndex(s => s.component === 'anamnesis')].loading = false })
    },

    async getAppointmentAnamnesis (appointmentId) {
      const officeId = await this.getAppointmentOffice(appointmentId)
      const anamnesis = await this.getOfficeAnamnesis(officeId)

      // retorna anamnese padrão ou as anamneses ativas
      return anamnesis.filter(a => !('is_active' in a) || (a['is_active']))
    },

    async getAppointmentOffice (appointmentId) {
      const { data } = await this.$http.get(
        `/doctor/agenda?filterAnd[a.id]=${appointmentId}`,
        this.$store.getters.getAuthHeader
      )
      return data.data[0].doctorOfficeId
    },

    async getOfficeAnamnesis (officeId) {
      const { data } = await this.$http.get(
        `/doctor/doctor_office/${officeId}/custom_anamnesis?itensPerPage=100`,
        this.$store.getters.getAuthHeader
      )
      return data.data
    },

    setAnamnesisList (list) {
      const index = this.sections.findIndex(s => s.component === 'anamnesis')
      this.sections[index].loading = true
      this.sections[index].options = list
      list.length > 0 && this.sections[index].options.unshift({ id: null, name: 'Anamnese padrão' })
    },

    selectComponent (section) {
      this.$emit('change', section.component)
      this.resetAnamnesisMenu()
    },

    toggleAnamnesisList (section) {
      section.showList = !section.showList
    },

    chooseAnamnesis (anamnesisId) {
      this.$emit('change', 'anamnesis', anamnesisId)
    },

    resetAnamnesisMenu () {
      const index = this.sections.findIndex(s => s.component === 'anamnesis')
      this.sections[index].showList = false
    }
  }
}
</script>
